import { render, staticRenderFns } from "./aiToolsBtn.vue?vue&type=template&id=beee3984&scoped=true"
import script from "./aiToolsBtn.vue?vue&type=script&lang=js"
export * from "./aiToolsBtn.vue?vue&type=script&lang=js"
import style0 from "./aiToolsBtn.vue?vue&type=style&index=0&id=beee3984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beee3984",
  null
  
)

export default component.exports